export default "__VITE_ASSET__CtRKV1UZ__"